import { render } from "./CreateExtract.vue?vue&type=template&id=455f8128&scoped=true"
import script from "./CreateExtract.vue?vue&type=script&lang=js"
export * from "./CreateExtract.vue?vue&type=script&lang=js"

import "./CreateExtract.vue?vue&type=style&index=0&id=455f8128&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455f8128"]])

export default __exports__